import bookingSvcAPIHelper from './bookingSvcAPIHelper';

/**
 * @declaration addDivrtToken
 * @param {*} data is request data received from each API call.
 * @returns data + divrt token
 */
 const addDivrtToken = (data) => {
  return Object.assign(data, { divrt: localStorage.getItem("divrtToken") });
}
/**
 * All declarations
 * @param {*} data is request data received from each API call.
 * @returns response
 */
const getLaneInfo = async (data) => {
  return await bookingSvcAPIHelper('POST', '/api/v1/kiosk/getKioskDebugData', addDivrtToken(data))
}

/**
 * export declarations
 */
export {
  getLaneInfo
}